<script>
  export let fill = "#3d4682";
  export let style = "";
  export let isActive = false;
  export let isOnSlide = false;
  export let even = true;
  export let needsExtraHeight = false;

  import { isMobile } from "../../stores/global.js";

  let top = Math.random() * 100;
  let left = Math.random() * 100;

  let bounds = [10, 90];
  let textBounds =
    (needsExtraHeight || $isMobile) && even
      ? [10, 30]
      : (needsExtraHeight || $isMobile) && !even
      ? [70, 90]
      : !even
      ? [45, 60]
      : [35, 50];

  if (isOnSlide) {
    while (
      (top < textBounds[1] && top > textBounds[0]) ||
      top < bounds[0] ||
      top > bounds[1]
    ) {
      top = Math.random() * 100;
    }
  }

  // HERO STARS
  if (!isOnSlide) {
    while (top > 30 && top < 70) {
      top = Math.random() * 100;
    }
  }

  let sizeOptions = [10, 15, 30];
  let size = sizeOptions[Math.floor(Math.random() * sizeOptions.length)];
</script>

<svg
  version="1.1"
  id="star"
  class="random-star"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 122.88 122.88"
  xml:space="preserve"
  style="top: {top}%; left: {left}%; width: {size}px; height: {size}px; {style}"
  {fill}
  class:isActive
  ><g
    ><path
      class="star"
      d="M62.43,122.88h-1.98c0-16.15-6.04-30.27-18.11-42.34C30.27,68.47,16.16,62.43,0,62.43v-1.98 c16.16,0,30.27-6.04,42.34-18.14C54.41,30.21,60.45,16.1,60.45,0h1.98c0,16.15,6.04,30.27,18.11,42.34 c12.07,12.07,26.18,18.11,42.34,18.11v1.98c-16.15,0-30.27,6.04-42.34,18.11C68.47,92.61,62.43,106.72,62.43,122.88L62.43,122.88z"
    /></g
  ></svg
>

<style>
  svg {
    fill-rule: evenodd;
    clip-rule: evenodd;
    position: absolute;
    z-index: 2;
    transition: fill 300ms ease;
  }

  :global(.swiper-slide-active #star) {
    z-index: 4;
  }

  svg:hover {
    fill: white;
    cursor: crosshair;
  }

  svg.isActive {
    animation: activeStarAnimation 3000ms ease infinite;
  }

  @keyframes activeStarAnimation {
    0% {
      transform: rotate(0deg) scale(1);
    }
    50% {
      transform: rotate(180deg) scale(1.2);
    }
    100% {
      transform: rotate(0deg) scale(1);
    }
  }
</style>
